/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { message as showMessage } from 'antd';
import i18n from './i18n';
import { getDuration } from './utils/duration';

const defaultDuration = 5;

export const showErrorMessage = (content = 'Error', duration = defaultDuration) =>
  void showMessage.error(content, duration);

const onError = (error: any): void => {
  const code = error?.response?.data?.code;
  const message = error?.response?.data?.message || error.message;
  const status = error?.response?.status.toString();

  console.log(`onError`);

  switch (code) {
    case 'NOT_SUFFICIENT_FUNDS': {
      showErrorMessage(i18n.t('errors:NOT_SUFFICIENT_FUNDS'));
      break;
    }
    case 'IDENTITY_IS_BLOCKED': {
      if (status === '401') {
        const block = error?.response?.data?.details?.block;
        const duration = getDuration(block);
        if (duration) {
          showErrorMessage(
            i18n.t(
              'You are temporarily locked due to multiple failed attempts. Please try again in {{duration}}.',
              { duration }
            )
          );
        } else {
          showErrorMessage(i18n.t('Your account is locked permanently'));
        }
      } else {
        showErrorMessage(error?.response?.data?.details?.reason || message, 15);
      }
      break;
    }
    case 'NOT_AUTHENTICATED': {
      if (status === '401') {
        const key =
          message?.indexOf('Wrong one-time code') >= 0
            ? message?.indexOf('Too many attempts') >= 0
              ? 'wrongOtpCodeTooManyAttempts'
              : 'wrongOtpCode'
            : 'wrongPasswordOrEmail';
        showErrorMessage(i18n.t(key), 5);
      } else {
        showErrorMessage(error.message);
      }
      break;
    }
    case 'REPORTS_TO_WITHOUT_TERMINAL': {
      showErrorMessage(i18n.t('reportsToWithoutTerminalErrorMessage'), 7);
      break;
    }
    case 'EMPLOYEE_WITHOUT_TERMINAL': {
      showErrorMessage(i18n.t('employeeWithoutTerminalErrorMessage'), 7);
      break;
    }
    case 'EMPLOYEE_IS_PART_OF_TREE': {
      showErrorMessage(i18n.t('employeeIsPartOfTheTreeTerminalErrorMessage'), 7);
      break;
    }
    default: {
      if (status === '413') {
        showErrorMessage(i18n.t('File payload is too large'));
      } else {
        showErrorMessage(message);
      }
    }
  }
};

export default onError;
